module.exports = [
    {
        "name_en": "Afghanistan",
        "country_code2": "AF",
        "country_code3": "AFG",
        "name_zh": "阿富汗",
        "name_tw": "阿富汗"
    },
    {
        "name_en": "Aland Islands",
        "country_code2": "AX",
        "country_code3": "ALA",
        "name_zh": "奥兰群岛",
        "name_tw": "奧蘭群島"
    },
    {
        "name_en": "Albania",
        "country_code2": "AL",
        "country_code3": "ALB",
        "name_zh": "阿尔巴尼亚",
        "name_tw": "阿爾巴尼亞"
    },
    {
        "name_en": "Algeria",
        "country_code2": "DZ",
        "country_code3": "DZA",
        "name_zh": "阿尔及利亚",
        "name_tw": "阿爾及利亞"
    },
    {
        "name_en": "American Samoa",
        "country_code2": "AS",
        "country_code3": "ASM",
        "name_zh": "美属萨摩亚",
        "name_tw": "美屬薩摩亞"
    },
    {
        "name_en": "Andorra",
        "country_code2": "AD",
        "country_code3": "AND",
        "name_zh": "安道尔",
        "name_tw": "安道爾"
    },
    {
        "name_en": "Angola",
        "country_code2": "AO",
        "country_code3": "AGO",
        "name_zh": "安哥拉",
        "name_tw": "安哥拉"
    },
    {
        "name_en": "Anguilla",
        "country_code2": "AI",
        "country_code3": "AIA",
        "name_zh": "安圭拉",
        "name_tw": "安圭拉"
    },
    {
        "name_en": "Antarctica",
        "country_code2": "AQ",
        "country_code3": "ATA",
        "name_zh": "南极洲",
        "name_tw": "南極洲"
    },
    {
        "name_en": "Antigua and Barbuda",
        "country_code2": "AG",
        "country_code3": "ATG",
        "name_zh": "安提瓜和巴布达",
        "name_tw": "安提瓜和巴布達"
    },
    {
        "name_en": "Argentina",
        "country_code2": "AR",
        "country_code3": "ARG",
        "name_zh": "阿根廷",
        "name_tw": "阿根廷"
    },
    {
        "name_en": "Armenia",
        "country_code2": "AM",
        "country_code3": "ARM",
        "name_zh": "亚美尼亚",
        "name_tw": "亞美尼亞"
    },
    {
        "name_en": "Aruba",
        "country_code2": "AW",
        "country_code3": "ABW",
        "name_zh": "阿鲁巴岛",
        "name_tw": "阿魯巴島"
    },
    {
        "name_en": "Australia",
        "country_code2": "AU",
        "country_code3": "AUS",
        "name_zh": "澳大利亚",
        "name_tw": "澳大利亞"
    },
    {
        "name_en": "Austria",
        "country_code2": "AT",
        "country_code3": "AUT",
        "name_zh": "奥地利",
        "name_tw": "奧地利"
    },
    {
        "name_en": "Azerbaijan",
        "country_code2": "AZ",
        "country_code3": "AZE",
        "name_zh": "阿塞拜疆",
        "name_tw": "阿塞拜疆"
    },
    {
        "name_en": "Bahamas",
        "country_code2": "BS",
        "country_code3": "BHS",
        "name_zh": "巴哈马",
        "name_tw": "巴哈馬"
    },
    {
        "name_en": "Bahrain",
        "country_code2": "BH",
        "country_code3": "BHR",
        "name_zh": "巴林",
        "name_tw": "巴林"
    },
    {
        "name_en": "Bangladesh",
        "country_code2": "BD",
        "country_code3": "BGD",
        "name_zh": "孟加拉国",
        "name_tw": "孟加拉國"
    },
    {
        "name_en": "Barbados",
        "country_code2": "BB",
        "country_code3": "BRB",
        "name_zh": "巴巴多斯",
        "name_tw": "巴巴多斯"
    },
    {
        "name_en": "Belarus",
        "country_code2": "BY",
        "country_code3": "BLR",
        "name_zh": "白俄罗斯",
        "name_tw": "白俄羅斯"
    },
    {
        "name_en": "Belgium",
        "country_code2": "BE",
        "country_code3": "BEL",
        "name_zh": "比利时",
        "name_tw": "比利時"
    },
    {
        "name_en": "Belize",
        "country_code2": "BZ",
        "country_code3": "BLZ",
        "name_zh": "伯利兹",
        "name_tw": "伯利茲"
    },
    {
        "name_en": "Benin",
        "country_code2": "BJ",
        "country_code3": "BEN",
        "name_zh": "贝宁",
        "name_tw": "貝寧"
    },
    {
        "name_en": "Bermuda",
        "country_code2": "BM",
        "country_code3": "BMU",
        "name_zh": "百慕大",
        "name_tw": "百慕大"
    },
    {
        "name_en": "Bhutan",
        "country_code2": "BT",
        "country_code3": "BTN",
        "name_zh": "不丹",
        "name_tw": "不丹"
    },
    {
        "name_en": "Bolivia",
        "country_code2": "BO",
        "country_code3": "BOL",
        "name_zh": "玻利维亚",
        "name_tw": "玻利維亞"
    },
    {
        "name_en": "Bonaire, Saint Eustatius and Saba",
        "country_code2": "BQ",
        "country_code3": "BES",
        "name_zh": "博内尔岛、圣尤斯特歇斯和萨巴岛",
        "name_tw": "博內爾島、聖尤斯特歇斯和薩巴島"
    },
    {
        "name_en": "Bosnia and Herzegovina",
        "country_code2": "BA",
        "country_code3": "BIH",
        "name_zh": "波斯尼亚和黑塞哥维那",
        "name_tw": "波斯尼亞和黑塞哥維那"
    },
    {
        "name_en": "Botswana",
        "country_code2": "BW",
        "country_code3": "BWA",
        "name_zh": "博茨瓦纳",
        "name_tw": "博茨瓦納"
    },
    {
        "name_en": "Bouvet Island",
        "country_code2": "BV",
        "country_code3": "BVT",
        "name_zh": "布韦岛",
        "name_tw": "布韋島"
    },
    {
        "name_en": "Brazil",
        "country_code2": "BR",
        "country_code3": "BRA",
        "name_zh": "巴西",
        "name_tw": "巴西"
    },
    {
        "name_en": "British Indian Ocean Territory",
        "country_code2": "IO",
        "country_code3": "IOT",
        "name_zh": "英属印度洋领地",
        "name_tw": "英屬印度洋領地"
    },
    {
        "name_en": "British Virgin Islands",
        "country_code2": "VG",
        "country_code3": "VGB",
        "name_zh": "英属维尔京群岛",
        "name_tw": "英屬維爾京群島"
    },
    {
        "name_en": "Brunei",
        "country_code2": "BN",
        "country_code3": "BRN",
        "name_zh": "文莱",
        "name_tw": "文萊"
    },
    {
        "name_en": "Bulgaria",
        "country_code2": "BG",
        "country_code3": "BGR",
        "name_zh": "保加利亚",
        "name_tw": "保加利亞"
    },
    {
        "name_en": "Burkina Faso",
        "country_code2": "BF",
        "country_code3": "BFA",
        "name_zh": "布基纳法索",
        "name_tw": "布基納法索"
    },
    {
        "name_en": "Burundi",
        "country_code2": "BI",
        "country_code3": "BDI",
        "name_zh": "布隆迪",
        "name_tw": "布隆迪"
    },
    {
        "name_en": "Cambodia",
        "country_code2": "KH",
        "country_code3": "KHM",
        "name_zh": "柬埔寨",
        "name_tw": "柬埔寨"
    },
    {
        "name_en": "Cameroon",
        "country_code2": "CM",
        "country_code3": "CMR",
        "name_zh": "喀麦隆",
        "name_tw": "喀麥隆"
    },
    {
        "name_en": "Canada",
        "country_code2": "CA",
        "country_code3": "CAN",
        "name_zh": "加拿大",
        "name_tw": "加拿大"
    },
    {
        "name_en": "Cape Verde",
        "country_code2": "CV",
        "country_code3": "CPV",
        "name_zh": "佛得角",
        "name_tw": "佛得角"
    },
    {
        "name_en": "Cayman Islands",
        "country_code2": "KY",
        "country_code3": "CYM",
        "name_zh": "开曼群岛",
        "name_tw": "開曼群島"
    },
    {
        "name_en": "Central African Republic",
        "country_code2": "CF",
        "country_code3": "CAF",
        "name_zh": "中非共和国",
        "name_tw": "中非共和國"
    },
    {
        "name_en": "Chad",
        "country_code2": "TD",
        "country_code3": "TCD",
        "name_zh": "乍得",
        "name_tw": "乍得"
    },
    {
        "name_en": "Chile",
        "country_code2": "CL",
        "country_code3": "CHL",
        "name_zh": "智利",
        "name_tw": "智利"
    },
    {
        "name_en": "China",
        "country_code2": "CN",
        "country_code3": "CHN",
        "name_zh": "中国",
        "name_tw": "中國"
    },
    {
        "name_en": "Christmas Island",
        "country_code2": "CX",
        "country_code3": "CXR",
        "name_zh": "圣诞岛",
        "name_tw": "聖誕島"
    },
    {
        "name_en": "Cocos Islands",
        "country_code2": "CC",
        "country_code3": "CCK",
        "name_zh": "科科斯群岛",
        "name_tw": "科科斯群島"
    },
    {
        "name_en": "Colombia",
        "country_code2": "CO",
        "country_code3": "COL",
        "name_zh": "哥伦比亚",
        "name_tw": "哥倫比亞"
    },
    {
        "name_en": "Comoros",
        "country_code2": "KM",
        "country_code3": "COM",
        "name_zh": "科摩罗",
        "name_tw": "科摩羅"
    },
    {
        "name_en": "Cook Islands",
        "country_code2": "CK",
        "country_code3": "COK",
        "name_zh": "库克群岛",
        "name_tw": "庫克群島"
    },
    {
        "name_en": "Costa Rica",
        "country_code2": "CR",
        "country_code3": "CRI",
        "name_zh": "哥斯达黎加",
        "name_tw": "哥斯達黎加"
    },
    {
        "name_en": "Croatia",
        "country_code2": "HR",
        "country_code3": "HRV",
        "name_zh": "克罗地亚",
        "name_tw": "克羅地亞"
    },
    {
        "name_en": "Cuba",
        "country_code2": "CU",
        "country_code3": "CUB",
        "name_zh": "古巴",
        "name_tw": "古巴"
    },
    {
        "name_en": "Curacao",
        "country_code2": "CW",
        "country_code3": "CUW",
        "name_zh": "库拉索",
        "name_tw": "庫拉索"
    },
    {
        "name_en": "Cyprus",
        "country_code2": "CY",
        "country_code3": "CYP",
        "name_zh": "塞浦路斯",
        "name_tw": "塞浦路斯"
    },
    {
        "name_en": "Czech Republic",
        "country_code2": "CZ",
        "country_code3": "CZE",
        "name_zh": "捷克共和国",
        "name_tw": "捷克共和國"
    },
    {
        "name_en": "Democratic Republic of the Congo",
        "country_code2": "CD",
        "country_code3": "COD",
        "name_zh": "刚果民主共和国",
        "name_tw": "剛果民主共和國"
    },
    {
        "name_en": "Denmark",
        "country_code2": "DK",
        "country_code3": "DNK",
        "name_zh": "丹麦",
        "name_tw": "丹麥"
    },
    {
        "name_en": "Djibouti",
        "country_code2": "DJ",
        "country_code3": "DJI",
        "name_zh": "吉布提",
        "name_tw": "吉布提"
    },
    {
        "name_en": "Dominica",
        "country_code2": "DM",
        "country_code3": "DMA",
        "name_zh": "多米尼加",
        "name_tw": "多米尼加"
    },
    {
        "name_en": "Dominican Republic",
        "country_code2": "DO",
        "country_code3": "DOM",
        "name_zh": "多明尼加共和国",
        "name_tw": "多明尼加共和國"
    },
    {
        "name_en": "East Timor",
        "country_code2": "TL",
        "country_code3": "TLS",
        "name_zh": "东帝汶",
        "name_tw": "東帝汶"
    },
    {
        "name_en": "Ecuador",
        "country_code2": "EC",
        "country_code3": "ECU",
        "name_zh": "厄瓜多尔",
        "name_tw": "厄瓜多爾"
    },
    {
        "name_en": "Egypt",
        "country_code2": "EG",
        "country_code3": "EGY",
        "name_zh": "埃及",
        "name_tw": "埃及"
    },
    {
        "name_en": "El Salvador",
        "country_code2": "SV",
        "country_code3": "SLV",
        "name_zh": "萨尔瓦多",
        "name_tw": "薩爾瓦多"
    },
    {
        "name_en": "Equatorial Guinea",
        "country_code2": "GQ",
        "country_code3": "GNQ",
        "name_zh": "赤道几内亚",
        "name_tw": "赤道幾內亞"
    },
    {
        "name_en": "Eritrea",
        "country_code2": "ER",
        "country_code3": "ERI",
        "name_zh": "厄立特里亚",
        "name_tw": "厄立特里亞"
    },
    {
        "name_en": "Estonia",
        "country_code2": "EE",
        "country_code3": "EST",
        "name_zh": "爱沙尼亚",
        "name_tw": "愛沙尼亞"
    },
    {
        "name_en": "Ethiopia",
        "country_code2": "ET",
        "country_code3": "ETH",
        "name_zh": "埃塞俄比亚",
        "name_tw": "埃塞俄比亞"
    },
    {
        "name_en": "Falkland Islands",
        "country_code2": "FK",
        "country_code3": "FLK",
        "name_zh": "福克兰群岛",
        "name_tw": "福克蘭群島"
    },
    {
        "name_en": "Faroe Islands",
        "country_code2": "FO",
        "country_code3": "FRO",
        "name_zh": "法罗群岛",
        "name_tw": "法羅群島"
    },
    {
        "name_en": "Fiji",
        "country_code2": "FJ",
        "country_code3": "FJI",
        "name_zh": "斐济",
        "name_tw": "斐濟"
    },
    {
        "name_en": "Finland",
        "country_code2": "FI",
        "country_code3": "FIN",
        "name_zh": "芬兰",
        "name_tw": "芬蘭"
    },
    {
        "name_en": "France",
        "country_code2": "FR",
        "country_code3": "FRA",
        "name_zh": "法国",
        "name_tw": "法國"
    },
    {
        "name_en": "French Guiana",
        "country_code2": "GF",
        "country_code3": "GUF",
        "name_zh": "法属圭亚那",
        "name_tw": "法屬圭亞那"
    },
    {
        "name_en": "French Polynesia",
        "country_code2": "PF",
        "country_code3": "PYF",
        "name_zh": "法属波利尼西亚",
        "name_tw": "法屬波利尼西亞"
    },
    {
        "name_en": "French Southern Territories",
        "country_code2": "TF",
        "country_code3": "ATF",
        "name_zh": "法属南部领地",
        "name_tw": "法屬南部領地"
    },
    {
        "name_en": "Gabon",
        "country_code2": "GA",
        "country_code3": "GAB",
        "name_zh": "加蓬",
        "name_tw": "加蓬"
    },
    {
        "name_en": "Gambia",
        "country_code2": "GM",
        "country_code3": "GMB",
        "name_zh": "冈比亚",
        "name_tw": "岡比亞"
    },
    {
        "name_en": "Georgia",
        "country_code2": "GE",
        "country_code3": "GEO",
        "name_zh": "乔治亚州",
        "name_tw": "喬治亞州"
    },
    {
        "name_en": "Germany",
        "country_code2": "DE",
        "country_code3": "DEU",
        "name_zh": "德国",
        "name_tw": "德國"
    },
    {
        "name_en": "Ghana",
        "country_code2": "GH",
        "country_code3": "GHA",
        "name_zh": "加纳",
        "name_tw": "加納"
    },
    {
        "name_en": "Gibraltar",
        "country_code2": "GI",
        "country_code3": "GIB",
        "name_zh": "直布罗陀",
        "name_tw": "直布羅陀"
    },
    {
        "name_en": "Greece",
        "country_code2": "GR",
        "country_code3": "GRC",
        "name_zh": "希腊",
        "name_tw": "希臘"
    },
    {
        "name_en": "Greenland",
        "country_code2": "GL",
        "country_code3": "GRL",
        "name_zh": "格陵兰",
        "name_tw": "格陵蘭"
    },
    {
        "name_en": "Grenada",
        "country_code2": "GD",
        "country_code3": "GRD",
        "name_zh": "格林纳达",
        "name_tw": "格林納達"
    },
    {
        "name_en": "Guadeloupe",
        "country_code2": "GP",
        "country_code3": "GLP",
        "name_zh": "瓜德罗普岛",
        "name_tw": "瓜德羅普島"
    },
    {
        "name_en": "Guam",
        "country_code2": "GU",
        "country_code3": "GUM",
        "name_zh": "关岛",
        "name_tw": "關島"
    },
    {
        "name_en": "Guatemala",
        "country_code2": "GT",
        "country_code3": "GTM",
        "name_zh": "危地马拉",
        "name_tw": "危地馬拉"
    },
    {
        "name_en": "Guernsey",
        "country_code2": "GG",
        "country_code3": "GGY",
        "name_zh": "根西岛",
        "name_tw": "根西島"
    },
    {
        "name_en": "Guinea",
        "country_code2": "GN",
        "country_code3": "GIN",
        "name_zh": "几内亚",
        "name_tw": "幾內亞"
    },
    {
        "name_en": "Guinea-Bissau",
        "country_code2": "GW",
        "country_code3": "GNB",
        "name_zh": "几内亚比绍",
        "name_tw": "幾內亞比紹"
    },
    {
        "name_en": "Guyana",
        "country_code2": "GY",
        "country_code3": "GUY",
        "name_zh": "圭亚那",
        "name_tw": "圭亞那"
    },
    {
        "name_en": "Haiti",
        "country_code2": "HT",
        "country_code3": "HTI",
        "name_zh": "海地",
        "name_tw": "海地"
    },
    {
        "name_en": "Heard Island and McDonald Islands",
        "country_code2": "HM",
        "country_code3": "HMD",
        "name_zh": "赫德岛和麦克唐纳群岛",
        "name_tw": "赫德島和麥克唐納群島"
    },
    {
        "name_en": "Honduras",
        "country_code2": "HN",
        "country_code3": "HND",
        "name_zh": "洪都拉斯",
        "name_tw": "洪都拉斯"
    },
    {
        "name_en": "Hong Kong",
        "country_code2": "HK",
        "country_code3": "HKG",
        "name_zh": "香港",
        "name_tw": "香港"
    },
    {
        "name_en": "Hungary",
        "country_code2": "HU",
        "country_code3": "HUN",
        "name_zh": "匈牙利",
        "name_tw": "匈牙利"
    },
    {
        "name_en": "Iceland",
        "country_code2": "IS",
        "country_code3": "ISL",
        "name_zh": "冰岛",
        "name_tw": "冰島"
    },
    {
        "name_en": "India",
        "country_code2": "IN",
        "country_code3": "IND",
        "name_zh": "印度",
        "name_tw": "印度"
    },
    {
        "name_en": "Indonesia",
        "country_code2": "ID",
        "country_code3": "IDN",
        "name_zh": "印度尼西亚",
        "name_tw": "印度尼西亞"
    },
    {
        "name_en": "Iran",
        "country_code2": "IR",
        "country_code3": "IRN",
        "name_zh": "伊朗",
        "name_tw": "伊朗"
    },
    {
        "name_en": "Iraq",
        "country_code2": "IQ",
        "country_code3": "IRQ",
        "name_zh": "伊拉克",
        "name_tw": "伊拉克"
    },
    {
        "name_en": "Ireland",
        "country_code2": "IE",
        "country_code3": "IRL",
        "name_zh": "爱尔兰",
        "name_tw": "愛爾蘭"
    },
    {
        "name_en": "Isle of Man",
        "country_code2": "IM",
        "country_code3": "IMN",
        "name_zh": "马恩岛",
        "name_tw": "馬恩島"
    },
    {
        "name_en": "Israel",
        "country_code2": "IL",
        "country_code3": "ISR",
        "name_zh": "以色列",
        "name_tw": "以色列"
    },
    {
        "name_en": "Italy",
        "country_code2": "IT",
        "country_code3": "ITA",
        "name_zh": "意大利",
        "name_tw": "意大利"
    },
    {
        "name_en": "Ivory Coast",
        "country_code2": "CI",
        "country_code3": "CIV",
        "name_zh": "象牙海岸",
        "name_tw": "象牙海岸"
    },
    {
        "name_en": "Jamaica",
        "country_code2": "JM",
        "country_code3": "JAM",
        "name_zh": "牙买加",
        "name_tw": "牙買加"
    },
    {
        "name_en": "Japan",
        "country_code2": "JP",
        "country_code3": "JPN",
        "name_zh": "日本",
        "name_tw": "日本"
    },
    {
        "name_en": "Jersey",
        "country_code2": "JE",
        "country_code3": "JEY",
        "name_zh": "球衣",
        "name_tw": "球衣"
    },
    {
        "name_en": "Jordan",
        "country_code2": "JO",
        "country_code3": "JOR",
        "name_zh": "约旦",
        "name_tw": "約旦"
    },
    {
        "name_en": "Kazakhstan",
        "country_code2": "KZ",
        "country_code3": "KAZ",
        "name_zh": "哈萨克斯坦",
        "name_tw": "哈薩克斯坦"
    },
    {
        "name_en": "Kenya",
        "country_code2": "KE",
        "country_code3": "KEN",
        "name_zh": "肯尼亚",
        "name_tw": "肯尼亞"
    },
    {
        "name_en": "Kiribati",
        "country_code2": "KI",
        "country_code3": "KIR",
        "name_zh": "基里巴斯",
        "name_tw": "基里巴斯"
    },
    {
        "name_en": "Kosovo",
        "country_code2": "XK",
        "country_code3": "XXK",
        "name_zh": "科索沃",
        "name_tw": "科索沃"
    },
    {
        "name_en": "Kuwait",
        "country_code2": "KW",
        "country_code3": "KWT",
        "name_zh": "科威特",
        "name_tw": "科威特"
    },
    {
        "name_en": "Kyrgyzstan",
        "country_code2": "KG",
        "country_code3": "KGZ",
        "name_zh": "吉尔吉斯斯坦",
        "name_tw": "吉爾吉斯斯坦"
    },
    {
        "name_en": "Laos",
        "country_code2": "LA",
        "country_code3": "LAO",
        "name_zh": "老挝",
        "name_tw": "老撾"
    },
    {
        "name_en": "Latvia",
        "country_code2": "LV",
        "country_code3": "LVA",
        "name_zh": "拉脱维亚",
        "name_tw": "拉脫維亞"
    },
    {
        "name_en": "Lebanon",
        "country_code2": "LB",
        "country_code3": "LBN",
        "name_zh": "黎巴嫩",
        "name_tw": "黎巴嫩"
    },
    {
        "name_en": "Lesotho",
        "country_code2": "LS",
        "country_code3": "LSO",
        "name_zh": "莱索托",
        "name_tw": "萊索托"
    },
    {
        "name_en": "Liberia",
        "country_code2": "LR",
        "country_code3": "LBR",
        "name_zh": "利比里亚",
        "name_tw": "利比里亞"
    },
    {
        "name_en": "Libya",
        "country_code2": "LY",
        "country_code3": "LBY",
        "name_zh": "利比亚",
        "name_tw": "利比亞"
    },
    {
        "name_en": "Liechtenstein",
        "country_code2": "LI",
        "country_code3": "LIE",
        "name_zh": "列支敦士登",
        "name_tw": "列支敦士登"
    },
    {
        "name_en": "Lithuania",
        "country_code2": "LT",
        "country_code3": "LTU",
        "name_zh": "立陶宛",
        "name_tw": "立陶宛"
    },
    {
        "name_en": "Luxembourg",
        "country_code2": "LU",
        "country_code3": "LUX",
        "name_zh": "卢森堡",
        "name_tw": "盧森堡"
    },
    {
        "name_en": "Macao",
        "country_code2": "MO",
        "country_code3": "MAC",
        "name_zh": "澳门",
        "name_tw": "澳門"
    },
    {
        "name_en": "Macedonia",
        "country_code2": "MK",
        "country_code3": "MKD",
        "name_zh": "马其顿",
        "name_tw": "馬其頓"
    },
    {
        "name_en": "Madagascar",
        "country_code2": "MG",
        "country_code3": "MDG",
        "name_zh": "马达加斯加",
        "name_tw": "馬達加斯加"
    },
    {
        "name_en": "Malawi",
        "country_code2": "MW",
        "country_code3": "MWI",
        "name_zh": "马拉维",
        "name_tw": "馬拉維"
    },
    {
        "name_en": "Malaysia",
        "country_code2": "MY",
        "country_code3": "MYS",
        "name_zh": "马来西亚",
        "name_tw": "馬來西亞"
    },
    {
        "name_en": "Maldives",
        "country_code2": "MV",
        "country_code3": "MDV",
        "name_zh": "马尔代夫",
        "name_tw": "馬爾代夫"
    },
    {
        "name_en": "Mali",
        "country_code2": "ML",
        "country_code3": "MLI",
        "name_zh": "马里",
        "name_tw": "馬里"
    },
    {
        "name_en": "Malta",
        "country_code2": "MT",
        "country_code3": "MLT",
        "name_zh": "马耳他",
        "name_tw": "馬耳他"
    },
    {
        "name_en": "Marshall Islands",
        "country_code2": "MH",
        "country_code3": "MHL",
        "name_zh": "马绍尔群岛",
        "name_tw": "馬紹爾群島"
    },
    {
        "name_en": "Martinique",
        "country_code2": "MQ",
        "country_code3": "MTQ",
        "name_zh": "马提尼克",
        "name_tw": "馬提尼克"
    },
    {
        "name_en": "Mauritania",
        "country_code2": "MR",
        "country_code3": "MRT",
        "name_zh": "毛里塔尼亚",
        "name_tw": "毛里塔尼亞"
    },
    {
        "name_en": "Mauritius",
        "country_code2": "MU",
        "country_code3": "MUS",
        "name_zh": "毛里求斯",
        "name_tw": "毛里求斯"
    },
    {
        "name_en": "Mayotte",
        "country_code2": "YT",
        "country_code3": "MYT",
        "name_zh": "马约特岛",
        "name_tw": "馬約特島"
    },
    {
        "name_en": "Mexico",
        "country_code2": "MX",
        "country_code3": "MEX",
        "name_zh": "墨西哥",
        "name_tw": "墨西哥"
    },
    {
        "name_en": "Micronesia",
        "country_code2": "FM",
        "country_code3": "FSM",
        "name_zh": "密克罗尼西亚",
        "name_tw": "密克羅尼西亞"
    },
    {
        "name_en": "Moldova",
        "country_code2": "MD",
        "country_code3": "MDA",
        "name_zh": "摩尔多瓦",
        "name_tw": "摩爾多瓦"
    },
    {
        "name_en": "Monaco",
        "country_code2": "MC",
        "country_code3": "MCO",
        "name_zh": "摩纳哥",
        "name_tw": "摩納哥"
    },
    {
        "name_en": "Mongolia",
        "country_code2": "MN",
        "country_code3": "MNG",
        "name_zh": "蒙古",
        "name_tw": "蒙古"
    },
    {
        "name_en": "Montenegro",
        "country_code2": "ME",
        "country_code3": "MNE",
        "name_zh": "黑山",
        "name_tw": "黑山"
    },
    {
        "name_en": "Montserrat",
        "country_code2": "MS",
        "country_code3": "MSR",
        "name_zh": "蒙特塞拉特",
        "name_tw": "蒙特塞拉特"
    },
    {
        "name_en": "Morocco",
        "country_code2": "MA",
        "country_code3": "MAR",
        "name_zh": "摩洛哥",
        "name_tw": "摩洛哥"
    },
    {
        "name_en": "Mozambique",
        "country_code2": "MZ",
        "country_code3": "MOZ",
        "name_zh": "莫桑比克",
        "name_tw": "莫桑比克"
    },
    {
        "name_en": "Myanmar",
        "country_code2": "MM",
        "country_code3": "MMR",
        "name_zh": "缅甸",
        "name_tw": "緬甸"
    },
    {
        "name_en": "Namibia",
        "country_code2": "NA",
        "country_code3": "NAM",
        "name_zh": "纳米比亚",
        "name_tw": "納米比亞"
    },
    {
        "name_en": "Nauru",
        "country_code2": "NR",
        "country_code3": "NRU",
        "name_zh": "瑙鲁",
        "name_tw": "瑙魯"
    },
    {
        "name_en": "Nepal",
        "country_code2": "NP",
        "country_code3": "NPL",
        "name_zh": "尼泊尔",
        "name_tw": "尼泊爾"
    },
    {
        "name_en": "Netherlands",
        "country_code2": "NL",
        "country_code3": "NLD",
        "name_zh": "荷兰",
        "name_tw": "荷蘭"
    },
    {
        "name_en": "Netherlands Antilles",
        "country_code2": "AN",
        "country_code3": "ANT",
        "name_zh": "荷属安的列斯",
        "name_tw": "荷屬安的列斯"
    },
    {
        "name_en": "New Caledonia",
        "country_code2": "NC",
        "country_code3": "NCL",
        "name_zh": "新喀里多尼亚",
        "name_tw": "新喀裡多尼亞"
    },
    {
        "name_en": "New Zealand",
        "country_code2": "NZ",
        "country_code3": "NZL",
        "name_zh": "新西兰",
        "name_tw": "新西蘭"
    },
    {
        "name_en": "Nicaragua",
        "country_code2": "NI",
        "country_code3": "NIC",
        "name_zh": "尼加拉瓜",
        "name_tw": "尼加拉瓜"
    },
    {
        "name_en": "Niger",
        "country_code2": "NE",
        "country_code3": "NER",
        "name_zh": "尼日尔",
        "name_tw": "尼日爾"
    },
    {
        "name_en": "Nigeria",
        "country_code2": "NG",
        "country_code3": "NGA",
        "name_zh": "尼日利亚",
        "name_tw": "尼日利亞"
    },
    {
        "name_en": "Niue",
        "country_code2": "NU",
        "country_code3": "NIU",
        "name_zh": "纽埃",
        "name_tw": "紐埃"
    },
    {
        "name_en": "Norfolk Island",
        "country_code2": "NF",
        "country_code3": "NFK",
        "name_zh": "诺福克岛",
        "name_tw": "諾福克島"
    },
    {
        "name_en": "North Korea",
        "country_code2": "KP",
        "country_code3": "PRK",
        "name_zh": "北朝鲜",
        "name_tw": "北朝鮮"
    },
    {
        "name_en": "Northern Mariana Islands",
        "country_code2": "MP",
        "country_code3": "MNP",
        "name_zh": "北马里亚纳群岛",
        "name_tw": "北馬里亞納群島"
    },
    {
        "name_en": "Norway",
        "country_code2": "NO",
        "country_code3": "NOR",
        "name_zh": "挪威",
        "name_tw": "挪威"
    },
    {
        "name_en": "Oman",
        "country_code2": "OM",
        "country_code3": "OMN",
        "name_zh": "阿曼",
        "name_tw": "阿曼"
    },
    {
        "name_en": "Pakistan",
        "country_code2": "PK",
        "country_code3": "PAK",
        "name_zh": "巴基斯坦",
        "name_tw": "巴基斯坦"
    },
    {
        "name_en": "Palau",
        "country_code2": "PW",
        "country_code3": "PLW",
        "name_zh": "帕劳",
        "name_tw": "帕勞"
    },
    {
        "name_en": "Palestinian Territory",
        "country_code2": "PS",
        "country_code3": "PSE",
        "name_zh": "巴勒斯坦领土",
        "name_tw": "巴勒斯坦領土"
    },
    {
        "name_en": "Panama",
        "country_code2": "PA",
        "country_code3": "PAN",
        "name_zh": "巴拿马",
        "name_tw": "巴拿馬"
    },
    {
        "name_en": "Papua New Guinea",
        "country_code2": "PG",
        "country_code3": "PNG",
        "name_zh": "巴布亚新几内亚",
        "name_tw": "巴布亞新幾內亞"
    },
    {
        "name_en": "Paraguay",
        "country_code2": "PY",
        "country_code3": "PRY",
        "name_zh": "巴拉圭",
        "name_tw": "巴拉圭"
    },
    {
        "name_en": "Peru",
        "country_code2": "PE",
        "country_code3": "PER",
        "name_zh": "秘鲁",
        "name_tw": "秘魯"
    },
    {
        "name_en": "Philippines",
        "country_code2": "PH",
        "country_code3": "PHL",
        "name_zh": "菲律宾",
        "name_tw": "菲律賓"
    },
    {
        "name_en": "Pitcairn",
        "country_code2": "PN",
        "country_code3": "PCN",
        "name_zh": "皮特凯恩",
        "name_tw": "皮特凱恩"
    },
    {
        "name_en": "Poland",
        "country_code2": "PL",
        "country_code3": "POL",
        "name_zh": "波兰",
        "name_tw": "波蘭"
    },
    {
        "name_en": "Portugal",
        "country_code2": "PT",
        "country_code3": "PRT",
        "name_zh": "葡萄牙",
        "name_tw": "葡萄牙"
    },
    {
        "name_en": "Puerto Rico",
        "country_code2": "PR",
        "country_code3": "PRI",
        "name_zh": "波多黎各",
        "name_tw": "波多黎各"
    },
    {
        "name_en": "Qatar",
        "country_code2": "QA",
        "country_code3": "QAT",
        "name_zh": "卡塔尔",
        "name_tw": "卡塔爾"
    },
    {
        "name_en": "Republic of the Congo",
        "country_code2": "CG",
        "country_code3": "COG",
        "name_zh": "刚果共和国",
        "name_tw": "剛果共和國"
    },
    {
        "name_en": "Reunion",
        "country_code2": "RE",
        "country_code3": "REU",
        "name_zh": "团圆",
        "name_tw": "團圓"
    },
    {
        "name_en": "Romania",
        "country_code2": "RO",
        "country_code3": "ROU",
        "name_zh": "罗马尼亚",
        "name_tw": "羅馬尼亞"
    },
    {
        "name_en": "Russia",
        "country_code2": "RU",
        "country_code3": "RUS",
        "name_zh": "俄罗斯",
        "name_tw": "俄羅斯"
    },
    {
        "name_en": "Rwanda",
        "country_code2": "RW",
        "country_code3": "RWA",
        "name_zh": "卢旺达",
        "name_tw": "盧旺達"
    },
    {
        "name_en": "Saint Barthelemy",
        "country_code2": "BL",
        "country_code3": "BLM",
        "name_zh": "圣巴泰勒米",
        "name_tw": "聖巴泰勒米"
    },
    {
        "name_en": "Saint Helena",
        "country_code2": "SH",
        "country_code3": "SHN",
        "name_zh": "圣赫勒拿",
        "name_tw": "聖赫勒拿"
    },
    {
        "name_en": "Saint Kitts and Nevis",
        "country_code2": "KN",
        "country_code3": "KNA",
        "name_zh": "圣基茨和尼维斯",
        "name_tw": "聖基茨和尼維斯"
    },
    {
        "name_en": "Saint Lucia",
        "country_code2": "LC",
        "country_code3": "LCA",
        "name_zh": "圣卢西亚",
        "name_tw": "聖盧西亞"
    },
    {
        "name_en": "Saint Martin",
        "country_code2": "MF",
        "country_code3": "MAF",
        "name_zh": "圣马丁",
        "name_tw": "聖馬丁"
    },
    {
        "name_en": "Saint Pierre and Miquelon",
        "country_code2": "PM",
        "country_code3": "SPM",
        "name_zh": "圣皮埃尔和密克隆",
        "name_tw": "聖皮埃爾和密克隆"
    },
    {
        "name_en": "Saint Vincent and the Grenadines",
        "country_code2": "VC",
        "country_code3": "VCT",
        "name_zh": "圣文森特和格林纳丁斯",
        "name_tw": "聖文森特和格林納丁斯"
    },
    {
        "name_en": "Samoa",
        "country_code2": "WS",
        "country_code3": "WSM",
        "name_zh": "萨摩亚",
        "name_tw": "薩摩亞"
    },
    {
        "name_en": "San Marino",
        "country_code2": "SM",
        "country_code3": "SMR",
        "name_zh": "圣马力诺",
        "name_tw": "聖馬力諾"
    },
    {
        "name_en": "Sao Tome and Principe",
        "country_code2": "ST",
        "country_code3": "STP",
        "name_zh": "圣多美和普林西比",
        "name_tw": "聖多美和普林西比"
    },
    {
        "name_en": "Saudi Arabia",
        "country_code2": "SA",
        "country_code3": "SAU",
        "name_zh": "沙特阿拉伯",
        "name_tw": "沙特阿拉伯"
    },
    {
        "name_en": "Senegal",
        "country_code2": "SN",
        "country_code3": "SEN",
        "name_zh": "塞内加尔",
        "name_tw": "塞內加爾"
    },
    {
        "name_en": "Serbia",
        "country_code2": "RS",
        "country_code3": "SRB",
        "name_zh": "塞尔维亚",
        "name_tw": "塞爾維亞"
    },
    {
        "name_en": "Serbia and Montenegro",
        "country_code2": "CS",
        "country_code3": "SCG",
        "name_zh": "塞尔维亚和黑山",
        "name_tw": "塞爾維亞和黑山"
    },
    {
        "name_en": "Seychelles",
        "country_code2": "SC",
        "country_code3": "SYC",
        "name_zh": "塞舌尔",
        "name_tw": "塞舌爾"
    },
    {
        "name_en": "Sierra Leone",
        "country_code2": "SL",
        "country_code3": "SLE",
        "name_zh": "塞拉利昂",
        "name_tw": "塞拉利昂"
    },
    {
        "name_en": "Singapore",
        "country_code2": "SG",
        "country_code3": "SGP",
        "name_zh": "新加坡",
        "name_tw": "新加坡"
    },
    {
        "name_en": "Sint Maarten",
        "country_code2": "SX",
        "country_code3": "SXM",
        "name_zh": "圣马丁岛",
        "name_tw": "聖馬丁島"
    },
    {
        "name_en": "Slovakia",
        "country_code2": "SK",
        "country_code3": "SVK",
        "name_zh": "斯洛伐克",
        "name_tw": "斯洛伐克"
    },
    {
        "name_en": "Slovenia",
        "country_code2": "SI",
        "country_code3": "SVN",
        "name_zh": "斯洛文尼亚",
        "name_tw": "斯洛文尼亞"
    },
    {
        "name_en": "Solomon Islands",
        "country_code2": "SB",
        "country_code3": "SLB",
        "name_zh": "所罗门群岛",
        "name_tw": "所羅門群島"
    },
    {
        "name_en": "Somalia",
        "country_code2": "SO",
        "country_code3": "SOM",
        "name_zh": "索马里",
        "name_tw": "索馬里"
    },
    {
        "name_en": "South Africa",
        "country_code2": "ZA",
        "country_code3": "ZAF",
        "name_zh": "南非",
        "name_tw": "南非"
    },
    {
        "name_en": "South Georgia and the South Sandwich Islands",
        "country_code2": "GS",
        "country_code3": "SGS",
        "name_zh": "南乔治亚岛和南桑威奇群岛",
        "name_tw": "南喬治亞島和南桑威奇群島"
    },
    {
        "name_en": "South Korea",
        "country_code2": "KR",
        "country_code3": "KOR",
        "name_zh": "韩国",
        "name_tw": "韓國"
    },
    {
        "name_en": "South Sudan",
        "country_code2": "SS",
        "country_code3": "SSD",
        "name_zh": "南苏丹",
        "name_tw": "南蘇丹"
    },
    {
        "name_en": "Spain",
        "country_code2": "ES",
        "country_code3": "ESP",
        "name_zh": "西班牙",
        "name_tw": "西班牙"
    },
    {
        "name_en": "Sri Lanka",
        "country_code2": "LK",
        "country_code3": "LKA",
        "name_zh": "斯里兰卡",
        "name_tw": "斯里蘭卡"
    },
    {
        "name_en": "Sudan",
        "country_code2": "SD",
        "country_code3": "SDN",
        "name_zh": "苏丹",
        "name_tw": "蘇丹"
    },
    {
        "name_en": "Suriname",
        "country_code2": "SR",
        "country_code3": "SUR",
        "name_zh": "苏里南",
        "name_tw": "蘇里南"
    },
    {
        "name_en": "Svalbard and Jan Mayen",
        "country_code2": "SJ",
        "country_code3": "SJM",
        "name_zh": "斯瓦尔巴和扬马延",
        "name_tw": "斯瓦爾巴和揚馬延"
    },
    {
        "name_en": "Swaziland",
        "country_code2": "SZ",
        "country_code3": "SWZ",
        "name_zh": "斯威士兰",
        "name_tw": "斯威士蘭"
    },
    {
        "name_en": "Sweden",
        "country_code2": "SE",
        "country_code3": "SWE",
        "name_zh": "瑞典",
        "name_tw": "瑞典"
    },
    {
        "name_en": "Switzerland",
        "country_code2": "CH",
        "country_code3": "CHE",
        "name_zh": "瑞士",
        "name_tw": "瑞士"
    },
    {
        "name_en": "Syria",
        "country_code2": "SY",
        "country_code3": "SYR",
        "name_zh": "叙利亚",
        "name_tw": "敘利亞"
    },
    {
        "name_en": "Taiwan",
        "country_code2": "TW",
        "country_code3": "TWN",
        "name_zh": "台湾",
        "name_tw": "台灣"
    },
    {
        "name_en": "Tajikistan",
        "country_code2": "TJ",
        "country_code3": "TJK",
        "name_zh": "塔吉克斯坦",
        "name_tw": "塔吉克斯坦"
    },
    {
        "name_en": "Tanzania",
        "country_code2": "TZ",
        "country_code3": "TZA",
        "name_zh": "坦桑尼亚",
        "name_tw": "坦桑尼亞"
    },
    {
        "name_en": "Thailand",
        "country_code2": "TH",
        "country_code3": "THA",
        "name_zh": "泰国",
        "name_tw": "泰國"
    },
    {
        "name_en": "Togo",
        "country_code2": "TG",
        "country_code3": "TGO",
        "name_zh": "多哥",
        "name_tw": "多哥"
    },
    {
        "name_en": "Tokelau",
        "country_code2": "TK",
        "country_code3": "TKL",
        "name_zh": "托克劳",
        "name_tw": "托克勞"
    },
    {
        "name_en": "Tonga",
        "country_code2": "TO",
        "country_code3": "TON",
        "name_zh": "汤加",
        "name_tw": "湯加"
    },
    {
        "name_en": "Trinidad and Tobago",
        "country_code2": "TT",
        "country_code3": "TTO",
        "name_zh": "特立尼达和多巴哥",
        "name_tw": "特立尼達和多巴哥"
    },
    {
        "name_en": "Tunisia",
        "country_code2": "TN",
        "country_code3": "TUN",
        "name_zh": "突尼斯",
        "name_tw": "突尼斯"
    },
    {
        "name_en": "Turkey",
        "country_code2": "TR",
        "country_code3": "TUR",
        "name_zh": "火鸡",
        "name_tw": "火雞"
    },
    {
        "name_en": "Turkmenistan",
        "country_code2": "TM",
        "country_code3": "TKM",
        "name_zh": "土库曼斯坦",
        "name_tw": "土庫曼斯坦"
    },
    {
        "name_en": "Turks and Caicos Islands",
        "country_code2": "TC",
        "country_code3": "TCA",
        "name_zh": "特克斯和凯科斯群岛",
        "name_tw": "特克斯和凱科斯群島"
    },
    {
        "name_en": "Tuvalu",
        "country_code2": "TV",
        "country_code3": "TUV",
        "name_zh": "图瓦卢",
        "name_tw": "圖瓦盧"
    },
    {
        "name_en": "U.S. Virgin Islands",
        "country_code2": "VI",
        "country_code3": "VIR",
        "name_zh": "美属维尔京群岛",
        "name_tw": "美屬維爾京群島"
    },
    {
        "name_en": "Uganda",
        "country_code2": "UG",
        "country_code3": "UGA",
        "name_zh": "乌干达",
        "name_tw": "烏干達"
    },
    {
        "name_en": "Ukraine",
        "country_code2": "UA",
        "country_code3": "UKR",
        "name_zh": "乌克兰",
        "name_tw": "烏克蘭"
    },
    {
        "name_en": "United Arab Emirates",
        "country_code2": "AE",
        "country_code3": "ARE",
        "name_zh": "阿拉伯联合酋长国",
        "name_tw": "阿拉伯聯合酋長國"
    },
    {
        "name_en": "United Kingdom",
        "country_code2": "GB",
        "country_code3": "GBR",
        "name_zh": "英国",
        "name_tw": "英國"
    },
    {
        "name_en": "United States",
        "country_code2": "US",
        "country_code3": "USA",
        "name_zh": "美国",
        "name_tw": "美國"
    },
    {
        "name_en": "United States Minor Outlying Islands",
        "country_code2": "UM",
        "country_code3": "UMI",
        "name_zh": "美国本土外小岛屿",
        "name_tw": "美國本土外小島嶼"
    },
    {
        "name_en": "Uruguay",
        "country_code2": "UY",
        "country_code3": "URY",
        "name_zh": "乌拉圭",
        "name_tw": "烏拉圭"
    },
    {
        "name_en": "Uzbekistan",
        "country_code2": "UZ",
        "country_code3": "UZB",
        "name_zh": "乌兹别克斯坦",
        "name_tw": "烏茲別克斯坦"
    },
    {
        "name_en": "Vanuatu",
        "country_code2": "VU",
        "country_code3": "VUT",
        "name_zh": "瓦努阿图",
        "name_tw": "瓦努阿圖"
    },
    {
        "name_en": "Vatican",
        "country_code2": "VA",
        "country_code3": "VAT",
        "name_zh": "教廷",
        "name_tw": "教廷"
    },
    {
        "name_en": "Venezuela",
        "country_code2": "VE",
        "country_code3": "VEN",
        "name_zh": "委内瑞拉",
        "name_tw": "委內瑞拉"
    },
    {
        "name_en": "Vietnam",
        "country_code2": "VN",
        "country_code3": "VNM",
        "name_zh": "越南",
        "name_tw": "越南"
    },
    {
        "name_en": "Wallis and Futuna",
        "country_code2": "WF",
        "country_code3": "WLF",
        "name_zh": "瓦利斯和富图纳",
        "name_tw": "瓦利斯和富圖納"
    },
    {
        "name_en": "Western Sahara",
        "country_code2": "EH",
        "country_code3": "ESH",
        "name_zh": "撒哈拉沙漠西部",
        "name_tw": "撒哈拉沙漠西部"
    },
    {
        "name_en": "Yemen",
        "country_code2": "YE",
        "country_code3": "YEM",
        "name_zh": "也门",
        "name_tw": "也門"
    },
    {
        "name_en": "Zambia",
        "country_code2": "ZM",
        "country_code3": "ZMB",
        "name_zh": "赞比亚",
        "name_tw": "贊比亞"
    },
    {
        "name_en": "Zimbabwe",
        "country_code2": "ZW",
        "country_code3": "ZWE",
        "name_zh": "津巴布韦",
        "name_tw": "津巴布韋"
    }
]
